import { Home, Layers, Hammer, Building } from 'lucide-react';
import React from 'react';

export const mockData = {
  images: {
    hero: '/hero-perez.jpg',
    about: '/about-perez.jpg',
  },

  stats: [
    { value: '60+', label: "Années d'expérience" },
    { value: '1000+', label: 'Projets réalisés' },
    { value: '100%', label: 'Clients satisfaits' },
    { value: '2', label: 'Certifications' },
  ],

  services: [
    {
      icon: React.createElement(Home, { size: 24 }),
      title: 'Isolation des combles',
      description: 'Isolation thermique et acoustique pour un confort optimal',
      image: 'https://images.unsplash.com/photo-1670511146782-8f52c5a7bd08?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxpbnN1bGF0aW9ufGVufDB8fHx8MTc3MzA5NTgyMXww&ixlib=rb-4.1.0&q=85',
      features: [
        'Combles aménagés',
        'Combles perdus',
        'Matériaux écologiques',
        'Éligible aux aides CEE'
      ]
    },
    {
      icon: React.createElement(Layers, { size: 24 }),
      title: 'Isolation des murs',
      description: "Isolation par l'intérieur pour améliorer vos performances énergétiques",
      image: 'https://images.unsplash.com/photo-1607400201889-565b1ee75f8e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxpbnN1bGF0aW9ufGVufDB8fHx8MTc3MzA5NTgyMXww&ixlib=rb-4.1.0&q=85',
      features: [
        'Doublage sur ossature',
        'Doublage collé',
        'Traitement acoustique',
        'Finitions soignées'
      ]
    },
    {
      icon: React.createElement(Hammer, { size: 24 }),
      title: 'Plâtrerie',
      description: 'Travaux de plâtrerie et finitions intérieures de qualité',
      image: 'https://images.unsplash.com/photo-1543525324-26e03b510586?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxwbGFzdGVyaW5nfGVufDB8fHx8MTc3MzA5NTgyNXww&ixlib=rb-4.1.0&q=85',
      features: [
        'Cloisons sèches',
        'Enduits et finitions',
        'Aménagements intérieurs',
        'Rénovation complète'
      ]
    },
    {
      icon: React.createElement(Building, { size: 24 }),
      title: 'Faux plafonds',
      description: 'Installation de faux plafonds techniques et décoratifs',
      image: 'https://images.unsplash.com/photo-1543525324-dc2c9006d03d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxpbnN1bGF0aW9ufGVufDB8fHx8MTc3MzA5NTgyMXww&ixlib=rb-4.1.0&q=85',
      features: [
        'Plafonds acoustiques',
        'Plafonds décoratifs',
        'Systèmes modulaires',
        'Éclairage intégré'
      ]
    }
  ],

  realisations: [
    {
      title: 'Aménagement Bureaux Modernes',
      category: 'Faux plafonds et cloisons',
      image: '/realisations/projet1.jpg',
      description: 'Faux plafonds acoustiques, cloisons vitrées et finitions murales'
    },
    {
      title: 'Rénovation Villa Privée',
      category: 'Plâtrerie et isolation',
      image: '/realisations/projet2.jpg',
      description: 'Escalier en construction avec habillage plâtre et isolation'
    },
    {
      title: 'Salle de Bain Contemporaine',
      category: 'Plâtrerie et finitions',
      image: '/realisations/projet3.jpg',
      description: 'Rénovation complète avec plâtrerie et finitions murales'
    },
    {
      title: 'Local Commercial',
      category: 'Plâtrerie et peinture',
      image: '/realisations/projet4.jpg',
      description: 'Aménagement intérieur avec finitions colorées'
    },
    {
      title: 'Rénovation Appartement',
      category: 'Plâtrerie intérieure',
      image: '/realisations/projet5.jpg',
      description: 'Travaux de plâtrerie et préparation des murs'
    },
    {
      title: 'Projet Résidentiel',
      category: 'Isolation et cloisons',
      image: '/realisations/projet1.jpg',
      description: 'Isolation thermique et cloisons sèches'
    }
  ],

  testimonials: [
    {
      name: 'Marie Dupont',
      project: 'Isolation combles - Agen',
      text: 'Travail sérieux et soigné. L\'équipe est professionnelle et respectueuse. Je recommande vivement pour tous travaux d\'isolation.'
    },
    {
      name: 'Pierre Martin',
      project: 'Rénovation complète - Marmande',
      text: 'Excellent rapport qualité-prix. Les délais ont été respectés et le résultat dépasse nos attentes. Merci à toute l\'équipe !'
    },
    {
      name: 'Sophie Bernard',
      project: 'Aménagement bureaux - Nérac',
      text: 'Une entreprise à l\'écoute avec un réel savoir-faire. Les finitions sont impeccables. Nous faisons appel à eux régulièrement.'
    }
  ],

  faq: [
    {
      question: 'Quels sont les délais d\'intervention ?',
      answer: 'Nous nous engageons à vous fournir un devis dans les 48h suivant votre demande. Les délais d\'intervention varient selon l\'ampleur du projet, mais nous nous efforçons toujours de respecter les plannings convenus.'
    },
    {
      question: 'Êtes-vous certifiés RGE ?',
      answer: 'Oui, PEREZ & Fils dispose de l\'agrément RGE (Reconnu Garant de l\'Environnement). Cela vous permet de bénéficier des aides financières pour vos travaux de rénovation énergétique (CEE, MaPrimeRénov, etc.).'
    },
    {
      question: 'Intervenez-vous chez les particuliers et les professionnels ?',
      answer: 'Absolument ! Nous intervenons aussi bien auprès des particuliers que des professionnels, collectivités et organismes publics. Notre expérience nous permet de nous adapter à tous types de projets.'
    },
    {
      question: 'Quelle est votre zone d\'intervention ?',
      answer: 'Nous intervenons principalement dans le Lot-et-Garonne et les départements limitrophes (Gironde, Landes). N\'hésitez pas à nous contacter pour vérifier si nous pouvons intervenir chez vous.'
    },
    {
      question: 'Proposez-vous des garanties sur vos travaux ?',
      answer: 'Oui, tous nos travaux sont couverts par les garanties légales (garantie décennale, garantie de parfait achèvement). Nous sommes assurés pour tous nos chantiers.'
    }
  ],

  contact: {
    phone: '05.53.84.70.05',
    email: 'contact@perezetfils.com',
    address: {
      line1: 'SAS PEREZ ET FILS',
      line2: '523 route d\'Aiguillon - "Le Coustet"',
      city: '47160 BUZET-SUR-BAÏSE'
    }
  }
};
